/**
 * Format a date string into a human-readable locale string.
 *
 * @param {string|null} dateString - ISO date string to format.
 * @param {object}      [options]
 * @param {boolean}     [options.includeTime=false] - When true, appends HH:MM to the output.
 * @returns {string}
 */
export function formatDate(dateString, { includeTime = false } = {}) {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  const localeOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...(includeTime && { hour: '2-digit', minute: '2-digit' }),
  };

  return date.toLocaleDateString('en-US', localeOptions);
}
